import axiosConfig from '@/lib/axiosConfig';
import { API_URL } from '@/config.js';

const shlokaModule = {
  namespaced: true,
  state: {
    shlokaCache: {}, // Кеш для множественных шлок: { alias: shlokaData }
    shlokaItem: null, // Оставляем для обратной совместимости
  },
  mutations: {
    setShlokaItem(state, shloka) {
      state.shlokaItem = shloka;
    },
    setCachedShloka(state, { alias, shloka }) {
      // Используем Vue.set для реактивности или просто присваиваем
      state.shlokaCache[alias] = shloka;
    }
  },
  actions: {
    // Загрузка данных о шлоке по алиасу с кешированием
    fetchShloka({ commit, state }, alias) {
      // Проверяем кеш
      if (state.shlokaCache[alias]) {
        console.log(`Шлока ${alias} загружена из кеша`);
        commit('setShlokaItem', state.shlokaCache[alias]);
        return Promise.resolve(state.shlokaCache[alias]);
      }
      
      // Если нет в кеше, загружаем
      return axiosConfig
        .get(API_URL, {
          params: {
            action: 'get_shloka',
            alias: alias
          },
        })
        .then(response => {
          const shloka = response.data.shloka;
          // Сохраняем в кеш
          commit('setCachedShloka', { alias, shloka });
          // Также сохраняем как текущий элемент для обратной совместимости
          commit('setShlokaItem', shloka);
          return shloka;
        })
        .catch(error => {
          console.error('Ошибка при загрузке шлоки:', error);
          throw error;
        });
    },
    
    // Очистка кеша (может пригодиться)
    clearShlokaCache({ state }) {
      state.shlokaCache = {};
      state.shlokaItem = null;
    }
  },
  getters: {
    getShlokaItem(state) {
      return state.shlokaItem;
    },
    getCachedShloka: (state) => (alias) => {
      return state.shlokaCache[alias] || null;
    },
    getAllCachedShlokas(state) {
      return state.shlokaCache;
    }
  }
};

export default shlokaModule;
